import './layer.scss';
// import Language from '../../language';
// const lang = new Language();

const layer = {
	msg: (title, opt, fn) => {
		// const layerHtml = `<div class="plugin-layer-box msg"><p>${title}</p></div>`;

		const layerHtml = document.createElement('div');
		layerHtml.innerHTML = `<div class="plugin-layer-box msg"><p>${title}</p></div>`;

		document.body.appendChild(layerHtml);

		if (opt) {
			setTimeout(() => {
				fn();
				document.body.removeChild(layerHtml)
			}, opt.time)
		} else {
			setTimeout(() => {
				document.body.removeChild(layerHtml)
			}, 2000)
		}
		
	}
}

export { layer }